import React, { useState } from 'react';
import { faqs } from '../data/mockData';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const FAQ = () => {
  const [openId, setOpenId] = useState(0);

  return (
    <section id="support" className="py-20 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <SafeIcon icon={FiIcons.FiSettings} className="mx-auto text-4xl text-gray-300 mb-4" />
          <h2 className="text-3xl font-black text-slate-900 uppercase tracking-tight">Need Help?</h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <div key={idx} className="border border-gray-200 rounded-sm overflow-hidden">
              <button 
                onClick={() => setOpenId(openId === idx ? null : idx)}
                className="w-full text-left px-6 py-4 bg-gray-50 hover:bg-gray-100 flex justify-between items-center focus:outline-none"
              >
                <span className="font-bold text-slate-800">{faq.q}</span>
                <SafeIcon 
                  icon={openId === idx ? FiIcons.FiMinus : FiIcons.FiPlus} 
                  className={`text-lime-500 transition-transform ${openId === idx ? 'rotate-180' : ''}`} 
                />
              </button>
              {openId === idx && (
                <div className="px-6 py-4 bg-white text-slate-600 border-t border-gray-100 leading-relaxed">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;